/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  set.add(value);
  return set;
}

export default addSetEntry;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/_addSetEntry.js
// module id = 341
// module chunks = 0